import { create } from 'zustand';
import { conditionalDevtools } from '@/lib/storeMiddleware';

interface MoveToFolderStoreState {
  isOpen: boolean;
  emailIds: string[];
  /**
   * Per-id context for targets that aren't loaded in the email store (search
   * result rows, N16) — the picker falls back to these when the shared
   * resolver can't place an id.
   */
  contextHints: Record<string, { accountId: string; folderId: string | null }>;
  open: (
    emailIds: string[],
    contextHints?: Record<string, { accountId: string; folderId: string | null }>
  ) => void;
  close: () => void;
}

export const useMoveToFolderStore = create<MoveToFolderStoreState>()(
  conditionalDevtools(
    (set) => ({
      isOpen: false,
      emailIds: [],
      contextHints: {},

      open: (emailIds, contextHints = {}) => {
        if (!emailIds.length) return;
        set({ isOpen: true, emailIds, contextHints });
      },

      close: () => {
        set({ isOpen: false, emailIds: [], contextHints: {} });
      },
    }),
    { name: 'MoveToFolderStore' }
  )
);
